<main class="container" *ngIf="trip_Obj">

    <!-- پرداخت موفقیت آمیز -->

    <section *ngIf="trip_Obj?.iResult == 1" class="success-container border border-2 rounded p-md-3 px-2">

        <!-- پیغام -->

        <div class="alert alert-success w-100 d-flex align-items-center justify-content-center" role="alert">

            <span class="fw-bold mx-1"> {{ trip_Obj?.strMessage }} </span>

        </div>

        <!-- مبلغ پرداخت شده -->

        <div class="w-100 row gx-0 gy-0 px-2">

            <p class="col-6 fw-bold text-muted"> مبلغ پرداخت شده</p>

            <p class="col-6 text-end text-purple">

                {{ trip_Obj.iChargingFee | number: '1.0-0' | faNum}} ریال

            </p>

        </div>

        <!-- توضیحات -->

        <div class="alert alert-success w-100" role="alert">

            <p class="fw-bold mx-1 " style="font-size: 13px;"> شماره تراکنش : {{ trip_Obj.strRefId | faNum }} </p>

            <p class="fw-bold mx-1 " style="font-size: 13px;"> نام خودرو : {{ trip_Obj.strFullName | faNum }} </p>

            <p class="fw-bold mx-1 " style="font-size: 13px;"> تاریخ پایان اعتبار : {{ trip_Obj.strValidDate | faNum }}
            </p>


        </div>

    </section>

    <!-- پرداخت ناموفق -->

    <section *ngIf="trip_Obj?.iResult == 0" class="failed-container border border-2 rounded p-md-3 px-2">

        <!-- پرداخت ناموفق -->

        <div class="alert alert-danger w-100 d-flex align-items-center justify-content-center" role="alert">

            <i class="fa fa-times fa-lg" aria-hidden="true"></i>

            <span class="fw-bold mx-1"> پرداخت شما ناموفق بود. </span>

        </div>

        <!-- بازگشت وجه -->

        <div class="w-100 row gx-0 gy-0 px-2 alert alert-secondary" role="alert">

            <p class="refund-text fw-bold mb-0 text-muted col-12" style="font-size: 12px;line-height: 24px;">

                {{ trip_Obj.strError | faNum }}

            </p>

        </div>

        <!-- توضیحات -->

        <div class="alert alert-secondary w-100" role="alert">

            <p class="fw-bold mx-1 " style="font-size: 13px;"> شماره تراکنش :

                <span class="text-muted">

                    {{ trip_Obj.strRefId || 'نامشخص' | faNum }}

                </span>

            </p>

            <p class="fw-bold mx-1 " style="font-size: 13px;"> نام خودرو :

                <span class="text-muted">

                    {{ trip_Obj.strFullName || 'نامشخص' | faNum }}

                </span>

            </p>

            <p class="fw-bold mx-1 " style="font-size: 13px;"> تاریخ پایان اعتبار :

                <span class="text-muted">

                    {{ trip_Obj.strValidDate || 'نامشخص' | faNum }}

                </span>

            </p>


        </div>

    </section>

    <!-- مشاهده صفحه خودرو -->

    <div class="mt-2 px-2 px-md-0 d-flex justify-content-center">

        <ng-container *ngIf="bAndroid;else bWeb">

            <button class="btn btn-primary w-100" (click)="openApp()">

                <!-- <a class="text-white" [href]="return_SafeUrl(href_Android)"> -->

                بازگشت به اپلیکیشن

                <!-- </a> -->

            </button>

        </ng-container>

        <ng-template #bWeb>

            <button class="btn btn-primary w-100" [routerLink]="['/carInfo/',trip_Obj.strUnitID]">

                بازگشت به صفحه خودرو

            </button>

        </ng-template>

    </div>

</main>